import { AxiosError, AxiosResponse } from "axios";
import { apiInstance } from "./apiInstance";

type ApiErrorResponse = {
  error?: unknown;
  [key: string]: unknown;
};

export const ApiPostNoAuth = async (endUrl: string, userData: object | null | unknown): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    apiInstance
      .post(endUrl, userData)
      .then((responseJson: AxiosResponse) => {
        resolve(responseJson);
      })
      .catch((error: AxiosError<ApiErrorResponse>) => {
        if (
          error?.hasOwnProperty("response") &&
          error?.response?.hasOwnProperty("data") &&
          error?.response?.data?.hasOwnProperty("error") &&
          error?.response?.data?.error
        ) {
          reject(error?.response?.data);
        } else {
          reject(error?.response);
        }
      });
  });
};

export const ApiGetNoAuth = async (endUrl: string): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    apiInstance
      .get(endUrl)
      .then((responseJson: AxiosResponse) => {
        resolve(responseJson);
      })
      .catch((error: AxiosError<ApiErrorResponse>) => {
        if (
          error?.hasOwnProperty("response") &&
          error?.response?.hasOwnProperty("data") &&
          error?.response?.data?.hasOwnProperty("error") &&
          error?.response?.data?.error
        ) {
          reject(error?.response?.data);
        } else {
          reject(error?.response);
        }
      });
  });
};

